export default "__VITE_ASSET__D6AlV3AR__"